import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import ICON_NAMES from './IconNames';
export { ICON_NAMES };
Icon.propTypes = {
  name: PropTypes.oneOf(ICON_NAMES)
};
export default Icon;